var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 3.5,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "rotate(90 34.5 3.5)",
    fill: "#0D152B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 3.5,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "rotate(90 34.5 3.5)",
    stroke: "#E8EBED",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4909 18.9994L17.1837 22.0232C16.9389 22.2472 16.9389 22.6087 17.1837 22.8327C17.3003 22.9398 17.4594 23 17.6253 23C17.7913 23 17.9504 22.9398 18.067 22.8327L21.8159 19.4048C22.0614 19.181 22.0614 18.819 21.8159 18.5952L18.0672 15.1673C17.9504 15.0602 17.7913 15 17.6253 15C17.4594 15 17.3003 15.0602 17.1835 15.1673C16.9389 15.3914 16.9389 15.7528 17.1838 15.9768L20.4909 18.9994Z",
    fill: "url(#paint0_radial_3746_2380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4909 18.9994L17.1837 22.0232C16.9389 22.2472 16.9389 22.6087 17.1837 22.8327C17.3003 22.9398 17.4594 23 17.6253 23C17.7913 23 17.9504 22.9398 18.067 22.8327L21.8159 19.4048C22.0614 19.181 22.0614 18.819 21.8159 18.5952L18.0672 15.1673C17.9504 15.0602 17.7913 15 17.6253 15C17.4594 15 17.3003 15.0602 17.1835 15.1673C16.9389 15.3914 16.9389 15.7528 17.1838 15.9768L20.4909 18.9994Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4909 18.9994L17.1837 22.0232C16.9389 22.2472 16.9389 22.6087 17.1837 22.8327C17.3003 22.9398 17.4594 23 17.6253 23C17.7913 23 17.9504 22.9398 18.067 22.8327L21.8159 19.4048C22.0614 19.181 22.0614 18.819 21.8159 18.5952L18.0672 15.1673C17.9504 15.0602 17.7913 15 17.6253 15C17.4594 15 17.3003 15.0602 17.1835 15.1673C16.9389 15.3914 16.9389 15.7528 17.1838 15.9768L20.4909 18.9994Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3746_2380",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5 19) scale(2.5 4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A33B3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewModal);
export default __webpack_public_path__ + "static/media/View Modal.c8f475ebba9888c8c1c739bba14aa7a4.svg";
export { ForwardRef as ReactComponent };